import { useMemo, useCallback } from 'react';

import { InsuranceProviders, getInsuranceProviderById, UNSUPPORTED_DESTINATION } from '../enums/insurance-providers';
import { useCanShowWalletedInsurance, useWalletedInsuranceProviderId } from '../services/insurance-service';
import { useFulfillmentPlannerContext } from '../fulfillment-planner/context';

const CHECKBOX_INSURANCE_OPTIONS = [InsuranceProviders.ParcelGuard.name, InsuranceProviders.XCover.name];
const INSURANCE_CHECKBOX_ID = 'insure-for-checkbox';

export const useInsuranceCheckbox = () => {
  const { hasInsuranceProviderSelected, insuranceProvider, onInsuranceProviderChange, rateErrors } = useFulfillmentPlannerContext();

  const isWalletedInsuranceEligible = useCanShowWalletedInsurance();
  const walletedInsuranceProviderId = useWalletedInsuranceProviderId();

  const isChecked = useMemo(() => {
    return hasInsuranceProviderSelected && CHECKBOX_INSURANCE_OPTIONS.includes(insuranceProvider?.name);
  }, [hasInsuranceProviderSelected, insuranceProvider.name]);

  const onCheckboxChange = useCallback(() => {
    const walletedInsuranceProvider = getInsuranceProviderById(walletedInsuranceProviderId);
    const currentSelectedInsuranceId = insuranceProvider.insuranceProviderId;
    onInsuranceProviderChange(
      currentSelectedInsuranceId === walletedInsuranceProviderId ? InsuranceProviders.None.name : walletedInsuranceProvider?.name,
    );
  }, [insuranceProvider, walletedInsuranceProviderId, onInsuranceProviderChange]);

  const containsSupportedDestinationError = useMemo(() => {
    return rateErrors?.find((error) => error.length && error.includes(UNSUPPORTED_DESTINATION));
  }, [rateErrors]);

  return useMemo(
    () => ({
      containsSupportedDestinationError,
      hasInsuranceProviderSelected,
      INSURANCE_CHECKBOX_ID,
      isChecked,
      isWalletedInsuranceEligible,
      onCheckboxChange,
    }),
    [containsSupportedDestinationError, hasInsuranceProviderSelected, isChecked, isWalletedInsuranceEligible, onCheckboxChange],
  );
};
